// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_SmartSnippet.scss
// module id = 704
// module chunks = 18 88